export default __webpack_public_path__ + "static/media/JobTwo2.0d4d2a2f.jpg";